// Dashboard API defaults to port 8000 in local dev (8080 is the white-label VAP app).
const DEFAULT_SERVER_URL = "http://localhost:8000"
const DASHBOARD_DEV_PORT = "8000"
const VAP_DEV_PORT = "8080"

export function resolveServerUrl(): string {
  const envUrl = process.env.REACT_APP_SERVER_URL?.trim()

  if (process.env.NODE_ENV === "development") {
    // Use CRA dev-server proxy when unset (same-origin /api and /health requests).
    if (!envUrl) return ""

    if (envUrl.includes(`localhost:${VAP_DEV_PORT}`)) {
      console.warn(
        `[Config] REACT_APP_SERVER_URL uses :${VAP_DEV_PORT} (VAP app). ` +
          `Dashboard API runs on :${DASHBOARD_DEV_PORT}. Auto-correcting.`,
      )
      return envUrl.replace(
        `localhost:${VAP_DEV_PORT}`,
        `localhost:${DASHBOARD_DEV_PORT}`,
      )
    }
  }

  return envUrl || DEFAULT_SERVER_URL
}

export const API_BASE_URL = resolveServerUrl()

export const config = {
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL || "",
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || "",
  serverUrl: API_BASE_URL,
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
  successUrl:
    process.env.REACT_APP_SUCCESS_URL ||
    `${window.location.origin}/billing`,
  cancelUrl:
    process.env.REACT_APP_CANCEL_URL ||
    `${window.location.origin}/billing`,
}

if (process.env.NODE_ENV === "development") {
  console.log(
    "[Config] Server URL:",
    API_BASE_URL || "(proxy → http://localhost:8000)",
  )
  console.log("[Config] Supabase URL:", config.supabaseUrl ? "Set" : "Not set")
  console.log(
    "[Config] Stripe Key:",
    config.stripePublishableKey ? "Set" : "Not set",
  )
}
